import { API_URL } from "./http";



const refreshToken = () => `${API_URL}/refresh-token`;

const filterMicrosites = (
  partner,
  organisationType,
  interest,
  sectorId,
  subSectorId,
  size,
  name,
  rangeAF,
  rangeGL,
  rangeMS,
  rangeTZ,
  masterDataId,
  pageNumber=0,
  pageSize=50
) =>
  `${API_URL}/end-user/filterByMicrosite?${partner ? `subDomainName=${partner}&` : "subDomainName=partner-name&"
  }${sectorId ? `sectorId=${sectorId}&` : ""}${masterDataId ? `masterDataId=${masterDataId}&` : ""}${subSectorId ? `subSectorId=${subSectorId}&` : ""
  }${size ? `size=${size}&` : ""}${name ? `text=${name}&` : ""}${interest ? `assetType=${interest}&` : ""
  }${organisationType ? `organizationTypeId=${organisationType}&` : ""}${rangeAF ? `range=${rangeAF}&` : ""
  }${rangeGL ? `range=${rangeGL}&` : ""}${rangeMS ? `range=${rangeMS}&` : ""}${rangeTZ ? `range=${rangeTZ}&` : ""
  }&pageNumber=${pageNumber}&pageSize=${pageSize}`;

//   `${API_URL}/end-user/filterByMicrosite?${sectorId ? `sectorId=${sectorId}&` : ""
// }${subSectorId ? `subSectorId=${subSectorId}&` : ""}${size ? `size=${size}&` : ""}${text ? `text=${text}${name ? `name=${name}&` : ""}${interest ? `assetType=${interest}` : ""
// }`;

const filterFavorites = (
  partner,
  phoneNumber,
  organisationType,
  interest,
  sectorId,
  subSectorId,
  size,
  name,
  rangeAF,
  rangeGL,
  rangeMS,
  rangeTZ
) =>
  `${API_URL}/end-user/filterByfavMicrosite/${phoneNumber}?${partner ? `subDomainName=${partner}&` : ""
  }${sectorId ? `sectorId=${sectorId}&` : ""}${subSectorId ? `subSectorId=${subSectorId}&` : ""
  }${size ? `size=${size}&` : ""}${name ? `text=${name}&` : ""}${interest ? `assetType=${interest}&` : ""
  }${organisationType ? `organizationTypeId=${organisationType}&` : ""}${rangeAF ? `range=${rangeAF}&` : ""
  }${rangeGL ? `range=${rangeGL}&` : ""}${rangeMS ? `range=${rangeMS}&` : ""}${rangeTZ ? `range=${rangeTZ}&` : ""
  }`;

const getFilteredMaps = (
  organisationType,
  interest,
  sectorId,
  subSectorId,
  size,
  name
) =>
  `${API_URL}/end-user/filter-on-map?${sectorId ? `sectorId=${sectorId}&` : ""
  }${subSectorId ? `subSectorId=${subSectorId}&` : ""}${size ? `size=${size}&` : ""
  }${name ? `name=${name}&` : ""}${interest ? `assetType=${interest}&` : ""}${organisationType ? `organisationtype=${organisationType}&` : ""
  }`;

const searchOrganisations = (name) =>
  `${API_URL}/end-user/filter?${name ? `name=${name}` : ""}`;

// const getAllSectors = () => `${API_URL}/sector`;

const getAllProSettings = (micrositeId) =>
  `${API_URL}/end-user/all-tabs/${micrositeId}`

const getAllSectors = (partnerId) =>
  // `${API_URL}/sector/get-all-sectors/${partnerId}`;
  `${API_URL}/end-user/sector/${partnerId}`;


const getSubSectorsForFilter = (partnerId) =>
  `${API_URL}/end-user/get/sub-sector/${partnerId}`;

const getSubSectors = (partnerId) =>
  // `${API_URL}/sector/${sectorId ? sectorId : ""}`;
  `${API_URL}/end-user/sector/${partnerId}`;
//  `${API_URL}/end-user/get/sub-sector/${partnerId}`;

const getMicrositeDetails = (id) => `${API_URL}/end-user/get-microsites/${id}`;

const getMicrositeDetailsByName = (name) =>
  `${API_URL}/end-user/get-microsite/${name}`;

const getMicrositeLogo = (id) =>
  `${API_URL}/end-user/organization/microsite/${id}`;

const getMicrositeDetailsTabs = (id, tabConfigId) =>
  // `${API_URL}/end-user/organization/${id}/details?section=${tabName}`;
  `${API_URL}/end-user/organization/${id}/details?tabConfigId=${tabConfigId || "1e9a427c-1435-4b41-a8c2-d118a606a60e"}`
// `${API_URL}/end-user/organization/${id}/details?tabConfigId=  `;


const getAboutUsDetailsTabs = (id, tabName, tabConfigId) =>
  // `${API_URL}/end-user/organization/microsite/${id}/about-us-details?aboutUsEnum=${tabName}`;
  `${API_URL}/end-user/organization/microsite/${id}/about-us-details?aboutUsEnum=${tabName}&tabConfigId=${tabConfigId}`;
// ${API_URL}/end-user/organization/microsite/${id}/about-us-details?aboutUsEnum=${tabName}

const getNewsByDate = (paramData) =>
  // `${API_URL}/end-user/search-news-by-date/${id}?text=${text}`
  `${API_URL}/end-user/search-news-by-date/${paramData.id}?tabConfigId=${paramData.tabConfigId}`

const getContractsDetails = (id, tabConfigId) =>
  // `${API_URL}/end-user/organization/contracts/${id}`;
  `${API_URL}/end-user/organization/contracts/${id}?tabConfigId=${tabConfigId}`;

const getContactUsDetails = (id, tabName) =>
  `${API_URL}/end-user/contact-us/organization/${id}?contactUsTypeEnum=${tabName}`;

const getMicrositeDetailsVacancyTab = (id, tabName, tabConfigId) =>
  // `${API_URL}/end-user/organization/${id}/vacancy?apprenticeshipType=${tabName}`;
  `${API_URL}/end-user/organization/${id}/vacancy?apprenticeshipType=${tabName}&tabConfigId=${tabConfigId}`;
// organization/{micrositeId}/vacancy

const getsettings = (microSiteId, partnerId) =>
  // `${API_URL}/end-user/microsite/${microSiteId}/partner/pro-settings?partnerId=${partnerId}`
  `${API_URL}/end-user/all-tabs/${microSiteId}`


const getmaps = () => `${API_URL}/end-user/organization-coodinates?`;

const getMicrositeList = (id) => `${API_URL}/end-user/get-microsites/${id}`;

const getEndUserDetails = () => `${API_URL}/end-user/end-user-details`;
//
const getPartnerDetails = (partner) =>
  `${API_URL}/end-user/partner-details?${partner ? `subDomainName=${partner}` : "partnerName=partner-name"
  }`;


const getOnOrganisationType = (partnerId) =>
  // `${API_URL}/get-all-orgType/${partnerId}?toggle=true`;
  `${API_URL}/end-user/org-partner-types/${partnerId}/ORGANIZATION_TYPE`;


const postFeedbackForm = (partnerId) =>
  // `${API_URL}/end-user/endUser-feedback/${partnerId}`;
  `${API_URL}/end-user/addFeedback`;


const getPartnerCarousel = (partner) =>
  `${API_URL}/end-user/details?section=corousel&${partner ? `subDomainName=${partner}` : ""
  }`;

// const getEndUserAgeGroups = () => `${API_URL}/get-end-user-age-groups`;
const getEndUserAgeGroups = () => `${API_URL}/end-user/master-data/AGE_GROUP`;


const getWhatDoYouDo = (id) =>
  // `${API_URL}/end-user/end-user-tags/age-group/${id}`;
  `${API_URL}/end-user/master-data/age-tag-by-age-group/${id}`;


const getExperienceOfWork = (id) =>
  `${API_URL}/end-user/organization/microsite/${id}/experience-of-work`;

const getCountries = () => `${API_URL}/end-user/country-details`;

const signUpOrg = () => `${API_URL}/end-user/signup-organization`;

const getPartnerSupporterLogo = (partner) =>
  `${API_URL}/end-user/supportLogo/${partner}`;

const postBookmark = (micrositeId, mobileNumber) =>
  `${API_URL}/end-user/organization/microsite/addMicrositeAsFavorites/${micrositeId}/${mobileNumber}`;

const removeBookmark = (micrositeId, mobileNumber) =>
  `${API_URL}/end-user/organization/microsite/deleteFavoritesOfMicrosite/${micrositeId}/${mobileNumber}`;

const getBookmark = (mobileNumber, partner) =>
  `${API_URL}/end-user/organization/microsite/getFavorites/${mobileNumber}?${partner ? `subDomainName=${partner}` : ""
  }`;

const getReviews = (id, phone) => {
  return `${API_URL}/end-user/organization/microsite/getReview/${id}`;
};

const getFiles = (micrositeId) =>
  `${API_URL}/end-user/insuranceDocs/${micrositeId}`;

const download = (documentId, ageId) =>
  `${API_URL}/end-user/downloadDoc/${documentId}/ageTag/${ageId}`;

const sendDetails = () => `${API_URL}/end-user/create-profile`;

const help = () => `${API_URL}/end-user/getHelpSection?userRole=END_USER`;

const getFilteredHelpInfo = (userRole, searchKey) =>
  `${API_URL}/end-user/help-section/search/?userRole=${userRole}${searchKey ? `&text=${searchKey}` : ''}`


const deleteReview = (replyId) =>
  `${API_URL}/end-user/organization/microsite/deleteReview/${replyId}`;

const addReview = () => `${API_URL}/end-user/organization/microsite/addReview`;

const getLevels = (type) =>
  // `${API_URL}/end-user/getlevels`;
  `${API_URL}/end-user/master-data/${type}`;

const micrositeViewCount = (micrositeId) =>
  `${API_URL}/end-user/addMicrositeView/${micrositeId}`;

const contactPageViewCount = (micrositeId, tab_enum) =>
  `${API_URL}/end-user/addContactUsView/${micrositeId}?contactUsTypeEnum=${tab_enum}`;

const checkPhonenumber = (phoneNumber) =>
  `${API_URL}/check-PhoneNumber?phoneNumber=${phoneNumber}`;

const downloadBrochure = (productId) => `${API_URL}/end-user/download-brochure/${productId}`
const viewBrochure = (productId) => `${API_URL}/end-user/view-brochure/${productId}`

const getMicrositeView = (micrositeId) => `${API_URL}/end-user/addMicrositeView/${micrositeId}`

// const getTabsSearchData = (microSiteId) => `${API_URL}/end-user/search-courses-by-title/${microSiteId}`
// const getTabsSearchData = (microSiteId) => `${API_URL}/end-user/search-courses-by-title/${microSiteId}`
const getTabsSearchData = (paramData) => `${API_URL}/end-user/search-news-by-date/${paramData.id}?tabConfigId=${paramData.tabConfigId}`

const getAboutUsMissingDataTabs = (microSiteId) => `${API_URL}/end-user/missing-about-us/${microSiteId}`
const getContactUsMissingDataTabs = (microSiteId) => `${API_URL}/end-user/missing-contact-us/${microSiteId}`

const getMissingMainTabs = (microSiteId) => `${API_URL}/end-user/missing-tabs/${microSiteId}`

const getMasterDataIds = () => `${API_URL}/end-user/master-data/TABS`

const getOrgDirectoryData = ({
  partner, searchText, size = 15, pageNumber = 0
}) => `${API_URL}/end-user/filter-companies?subDomainName=${partner}&searchText=${searchText}&pageSize=${size}&pageNumber=${pageNumber}`

export default {
  refreshToken,
  filterMicrosites,
  getMasterDataIds,
  filterFavorites,
  getAllSectors,
  getSubSectors,
  getMicrositeDetailsTabs,
  getTabsSearchData,
  getAboutUsDetailsTabs,
  getContractsDetails,
  getMicrositeDetails,
  getMicrositeDetailsByName,
  getMicrositeLogo,
  getContactUsDetails,
  getMicrositeDetailsVacancyTab,
  getsettings,
  getmaps,
  getFilteredMaps,
  getMicrositeList,
  getEndUserDetails,
  searchOrganisations,
  getPartnerDetails,
  postFeedbackForm,
  getPartnerCarousel,
  getEndUserAgeGroups,
  getWhatDoYouDo,
  getExperienceOfWork,
  getCountries,
  signUpOrg,
  getPartnerSupporterLogo,
  postBookmark,
  removeBookmark,
  getBookmark,
  getReviews,
  getFiles,
  download,
  sendDetails,
  help,
  getFilteredHelpInfo,
  deleteReview,
  addReview,
  getLevels,
  micrositeViewCount,
  getOnOrganisationType,
  contactPageViewCount,
  checkPhonenumber,
  downloadBrochure,
  viewBrochure,
  getNewsByDate,
  getAllProSettings,
  getMicrositeView,
  getSubSectorsForFilter,
  getAboutUsMissingDataTabs,
  getContactUsMissingDataTabs,
  getMissingMainTabs,
  getOrgDirectoryData
};
